import { X } from "lucide-react";
import type { FC } from "react";

import { TurningMark } from "@/components/brand";
import { Button } from "@/components/ui/button";

type Props = {
  onReload: () => void;
  onDismiss: () => void;
};

/** A newer build is out. Nothing is blocked; it loads on the next page change. */
export const UpdateBanner: FC<Props> = ({ onReload, onDismiss }) => (
  <div
    role="status"
    data-testid="update-banner"
    className="fixed bottom-6 left-1/2 z-50 flex w-96 -translate-x-1/2 items-center gap-3 rounded-xl bg-elevated p-3 shadow-popover ring-1 ring-line-2"
  >
    <TurningMark turning="loop" />
    <div className="flex min-w-0 flex-1 flex-col gap-0.5">
      <span className="text-base font-medium text-fg">Update Ready</span>
      <span className="text-sm text-fg-3">
        It loads when you next change pages. Your drafts are kept.
      </span>
    </div>
    <Button variant="secondary" size="xs" onClick={onReload}>
      Reload Now
    </Button>
    <Button
      variant="ghost"
      size="icon-xs"
      aria-label="Dismiss"
      onClick={onDismiss}
    >
      <X />
    </Button>
  </div>
);
